
export class AssetListResponse {
    public vinNum: string;
    public assetID: string;
    public agreementNum: string;
    public model: string;
    public year: number;
    public onlinePayFlag: string;  
}
